import { MouseEventHandler, PropsWithChildren } from "react";

import { ModalTabButton } from "./styles";

/**
 * Button-like tab element meant to control a tabpanel within
 * a modal.
 */
export const ModalTab = ({
  children,
  onClick,
  isCurrent = false,
}: PropsWithChildren<ModalTabProps>) => {
  return (
    <ModalTabButton
      fullWidth
      onClick={onClick}
      role="tab"
      aria-selected={isCurrent}
      isCurrent={isCurrent}
      variant={isCurrent ? "primary" : "secondary"}
    >
      {children}
    </ModalTabButton>
  );
};

export type ModalTabProps = {
  /**
   * Action to perform when the tab is clicked.
   * This action should change the current tabpanel.
   */
  onClick: MouseEventHandler;
  /**
   * Whether this tab is currently selected, defaults to false.
   */
  isCurrent?: boolean;
};
